import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import CallMissedOutgoingIcon from "@mui/icons-material/CallMissedOutgoing";
import parse from "html-react-parser";
import { useLocation, useNavigate } from "react-router-dom";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import {
  commentInputCounter,
  noRatingCounter,
  totalCommentCounter,
  isSelectedLiveComment,
} from "../../Helpers/HelperFunctions";
import { resolveCommentRatings } from "../../Helpers/LineRatingUtils";
import {
  activateLines,
  getInspectionData,
} from "../../Redux/Actions/CommonActions";
import { useDispatch } from "react-redux";
import FlagIcon from '@mui/icons-material/Flag';


function CommentReview({ inspectionResponse, inspectionData, defaultRating }) {
  const navigate = useNavigate();
  useEffect(() => { }, [inspectionResponse]);
  const dispatch = useDispatch();
  const activateLine = (uuid) => {
    dispatch(activateLines(uuid));
  };
  function decodeHtmlEntities(str) {
    if (!str) return "";
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  }
  function processCommentContent(recommendation, commentDropdowns) {
    if (!recommendation) return "";
    
    return recommendation
      .replace(/\[dropdown\s+([a-f0-9-]+)\]/gi, (match, uuid) => {
        const dropdown = commentDropdowns?.find(item => item.dropdown_uuid === uuid);
        return decodeHtmlEntities(dropdown?.selected_value?.trim() || "");
      })
      .replace(/\[textbox\s+id:([a-f0-9-]+)([^\]]*)\]/gi,
        (match, id, inner) => {
          const vm = inner.match(/value\s*:\s*([^;]+)/i); 
          const value = vm ? vm[1].trim() : "";
          return value ? decodeHtmlEntities(value) + " " : "";
        })
      // Remove button tags
      .replace(/<button\b[^>]*>.*?<\/button>/gi, "")
      // Replace &nbsp; with empty space
      .replace(/&nbsp;/g, " ")
      // Remove all HTML tags
      .replace(/<\/?[^>]+(>|$)/g, "")
      .trim();
  }
  function getCommentDisplayText(comment) {
    const hasRecommendation = comment?.recommendation && 
      comment.recommendation.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ").trim() !== "";
    const hasPrompt = comment?.prompt && comment.prompt.trim() !== "";
    
    if (!hasRecommendation && !hasPrompt) {
      return "Untitled";
    }
    
    if (hasPrompt) {
      return comment.prompt;
    }
    
    return processCommentContent(comment.recommendation, comment.comment_dropdowns);
  }

  return (
    <Grid container className="coll_inner_div">
      <div className="coll_div right_padding">
        {inspectionResponse?.filter((pdf) => pdf?.is_pdf_template !== 1)?.map((template) =>
          <Grid container className="coll_inner_div" id={template?.template_id}>
            <span className="incomplete_temp">{template.name}</span>
            <div className="coll_div right_padding">
              <div className="card_wrapper">
                {template?.rating_data?.map((rating) => (
                  <>
                    <div className="coll_heading">
                      {commentInputCounter(rating, template)} {rating.Name}
                      <div className="div_header_rating rating_square_container"><span className="review_rating_square" style={{ background: `${rating.Color}` }}>{rating.include_in_summary == "1" && <FlagIcon />}</span></div>
                    </div>
                    {template?.is_narrative_template !== 1 && template?.categories?.map((category) => {
                      if (category?.prompt == "Inspection Details") return;
                      return category?.lines?.map((lines) => (
                        <>
                          {lines?.comments?.map((comment) =>
                            resolveCommentRatings(comment, template?.rating_data)
                              ?.map((el) =>
                                el?.Name === rating?.Name && isSelectedLiveComment(comment) ? (
                                  <>
                                    <div className="coll_content">
                                      <div>
                                        <p
                                          className="coll_content_text"
                                          onClick={() => {
                                            navigate(
                                              `/inspection/${category?.prompt !== null
                                                ? encodeURIComponent(
                                                  category.prompt
                                                )
                                                : "Untitled"
                                              }/${lines.prompt !== null
                                                ? encodeURIComponent(lines.prompt)
                                                : "Untitled"
                                              }`,
                                              {
                                                state: {
                                                  line: lines,
                                                  template_id: category?.template_id,
                                                  category_id: category?.id,
                                                  category_uuid: category?.uuid,
                                                  line_uuid: lines?.uuid,
                                                  isNarrative: template?.is_narrative_template === 1 ? true : false,
                                                  target: "comment",
                                                },
                                              }
                                            );
                                            activateLine(lines?.uuid);
                                          }}
                                        >
                                          {category.prompt === null
                                            ? "Untitled"
                                            : category.prompt}
                                          : {lines.prompt === null
                                            ? "Untitled"
                                            : lines.prompt}
                                        </p>
                                        <p
                                          className="coll_content_text"
                                          onClick={() => {
                                            navigate(
                                              `/inspection/${category?.prompt !== null
                                                ? encodeURIComponent(
                                                  category.prompt
                                                )
                                                : "Untitled"
                                              }/${lines.prompt !== null
                                                ? encodeURIComponent(lines.prompt)
                                                : "Untitled"
                                              }`,
                                              {
                                                state: {
                                                  line: lines,
                                                  template_id: category?.template_id,
                                                  category_id: category?.id,
                                                  category_uuid: category?.uuid,
                                                  line_uuid: lines?.uuid,
                                                  isNarrative: template?.is_narrative_template === 1 ? true : false,
                                                  target: "comment",
                                                },
                                              }
                                            );
                                            activateLine(lines?.uuid);
                                          }}
                                        >
                                          Comment:{"  "}
                                          {getCommentDisplayText(comment)}
                                        </p>
                                        <div className="review_image_container" style={{ display: "flex !important", flexFlow: "wrap !important" }}>
                                          {comment?.comment_input_controls?.map(
                                            (commentData) => {
                                              if (commentData?.type == "Media" && commentData?.is_disabled !== 1)
                                                return commentData?.data?.filter(media => media?.is_deleted === 0)?.map(
                                                  (media) => (
                                                    <div className="video_thumb_container">
                                                      {media.filetype === "image" ? "" : <PlayCircleIcon className="comment_play_icon" />}
                                                      <img
                                                        src={
                                                          media.filetype === "image"
                                                            ? `${inspectionData?.bucket_url}${media?.onlineUrl}`
                                                            : `${inspectionData?.bucket_url}${media?.thumbnail}`
                                                        }
                                                        onClick={() => {
                                                          navigate(
                                                            `/inspection/${category?.prompt !==
                                                              null
                                                              ? encodeURIComponent(
                                                                category.prompt
                                                              )
                                                              : "Untitled"
                                                            }/${lines.prompt !== null
                                                              ? encodeURIComponent(
                                                                lines.prompt
                                                              )
                                                              : "Untitled"
                                                            }`,
                                                            {
                                                              state: {
                                                                line: lines,
                                                                template_id:
                                                                  category?.template_id,
                                                                category_id:
                                                                  category?.id,
                                                                category_uuid:
                                                                  category?.uuid,
                                                                line_uuid:
                                                                  lines?.uuid,
                                                                isNarrative: template?.is_narrative_template === 1 ? true : false,
                                                                target: "comment",
                                                              },
                                                            }
                                                          );
                                                          activateLine(lines?.uuid);
                                                        }}
                                                      />
                                                    </div>
                                                  )
                                                );
                                            }
                                          )}
                                        </div>
                                      </div>
                                      <div>
                                        <CallMissedOutgoingIcon
                                          className="updrop_icon"
                                          onClick={() => {
                                            navigate(
                                              `/inspection/${category?.prompt !== null
                                                ? encodeURIComponent(
                                                  category.prompt
                                                )
                                                : "Untitled"
                                              }/${lines.prompt !== null
                                                ? encodeURIComponent(lines.prompt)
                                                : "Untitled"
                                              }`,
                                              {
                                                state: {
                                                  line: lines,
                                                  template_id: category?.template_id,
                                                  category_id: category?.id,
                                                  category_uuid: category?.uuid,
                                                  line_uuid: lines?.uuid,
                                                  isNarrative: template?.is_narrative_template === 1 ? true : false,
                                                  target: "comment",
                                                },
                                              }
                                            );
                                            activateLine(lines?.uuid);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )
                              )
                          )}
                        </>
                      ));
                    })}
                  </>
                ))}
                <div className="coll_heading">
                  {noRatingCounter(template, template?.is_narrative_template === 1 ? true : false)} Unrated{" "}
                  <div className="div_header_rating"></div>
                </div>
                {template?.categories?.map((category) => {
                  if (category?.prompt == "Inspection Details") return;
                  return category?.lines?.map((lines) => (
                    <>

                      {lines?.comments?.map((comment) => {
                        if (isSelectedLiveComment(comment)) {
                          if (!comment?.comment_input_controls?.length && resolveCommentRatings(comment, template?.rating_data)?.length === 0) {
                            return (
                              <>
                                <div className="coll_content">
                                  <div>
                                    <p
                                      className="coll_content_text"
                                      onClick={() => {
                                        navigate(
                                          `/inspection/${category?.prompt !== null
                                            ? encodeURIComponent(category.prompt)
                                            : "Untitled"
                                          }/${lines.prompt !== null
                                            ? encodeURIComponent(lines.prompt)
                                            : "Untitled"
                                          }`,
                                          {
                                            state: {
                                              line: lines,
                                              template_id: category?.template_id,
                                              category_id: category?.id,
                                              category_uuid: category?.uuid,
                                              line_uuid: lines?.uuid,
                                              isNarrative: template?.is_narrative_template === 1 ? true : false,
                                              target: "comment",
                                            },
                                          }
                                        );
                                        activateLine(lines?.uuid);
                                      }}
                                    >
                                      {category.prompt === null
                                        ? "Untitled"
                                        : category.prompt}
                                      : {lines.prompt === null
                                        ? "Untitled"
                                        : lines.prompt}
                                    </p>
                                    <p
                                      className="coll_content_text"
                                      onClick={() => {
                                        navigate(
                                          `/inspection/${category?.prompt !== null
                                            ? encodeURIComponent(category.prompt)
                                            : "Untitled"
                                          }/${lines.prompt !== null
                                            ? encodeURIComponent(lines.prompt)
                                            : "Untitled"
                                          }`,
                                          {
                                            state: {
                                              line: lines,
                                              template_id: category?.template_id,
                                              category_id: category?.id,
                                              category_uuid: category?.uuid,
                                              line_uuid: lines?.uuid,
                                              isNarrative: template?.is_narrative_template === 1 ? true : false,
                                              target: "comment",
                                            },
                                          }
                                        );
                                        activateLine(lines?.uuid);
                                      }}
                                    >
                                      Comment:{"  "}
                                      {getCommentDisplayText(comment)}
                                    </p>
                                    <div className="review_image_container" style={{ display: "flex !important", flexFlow: "wrap !important" }}>
                                      {comment?.comment_input_controls?.map(
                                        (commentData) => {
                                          if (commentData?.type == "Media" && commentData?.is_disabled !== 1)
                                            return commentData?.data?.filter(media => media?.is_deleted === 0)?.map((media) => (
                                              <div className="video_thumb_container">
                                                {media.filetype === "image" ? "" : <PlayCircleIcon className="comment_play_icon" />}
                                                <img
                                                  src={
                                                    media.filetype === "image"
                                                      ? `${inspectionData?.bucket_url}${media?.onlineUrl}`
                                                      : `${inspectionData?.bucket_url}${media?.thumbnail}`
                                                  }
                                                  onClick={() => {
                                                    navigate(
                                                      `/inspection/${category?.prompt !==
                                                        null
                                                        ? encodeURIComponent(
                                                          category.prompt
                                                        )
                                                        : "Untitled"
                                                      }/${lines.prompt !== null
                                                        ? encodeURIComponent(
                                                          lines.prompt
                                                        )
                                                        : "Untitled"
                                                      }`,
                                                      {
                                                        state: {
                                                          line: lines,
                                                          template_id:
                                                            category?.template_id,
                                                          category_id:
                                                            category?.id,
                                                          category_uuid:
                                                            category?.uuid,
                                                          line_uuid:
                                                            lines?.uuid,
                                                          isNarrative: template?.is_narrative_template === 1 ? true : false,
                                                          target: "comment",
                                                        },
                                                      }
                                                    );
                                                    activateLine(lines?.uuid);
                                                  }}
                                                />
                                              </div>
                                            ));
                                        }
                                      )}
                                    </div>
                                  </div>
                                  <div>
                                    <CallMissedOutgoingIcon
                                      className="updrop_icon"
                                      onClick={() => {
                                        navigate(
                                          `/inspection/${category?.prompt !== null
                                            ? encodeURIComponent(category.prompt)
                                            : "Untitled"
                                          }/${lines.prompt !== null
                                            ? encodeURIComponent(lines.prompt)
                                            : "Untitled"
                                          }`,
                                          {
                                            state: {
                                              line: lines,
                                              template_id: category?.template_id,
                                              category_id: category?.id,
                                              category_uuid: category?.uuid,
                                              line_uuid: lines?.uuid,
                                              isNarrative: template?.is_narrative_template === 1 ? true : false,
                                              target: "comment",
                                            },
                                          }
                                        );
                                        activateLine(lines?.uuid);
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            );
                          }
                          if (resolveCommentRatings(comment, template?.rating_data)?.length === 0) {
                            return (
                              <div className="coll_content">
                                <div>
                                  <p
                                    className="coll_content_text"
                                    onClick={() => {
                                      navigate(
                                        `/inspection/${category?.prompt !== null
                                          ? encodeURIComponent(category.prompt)
                                          : "Untitled"
                                        }/${lines.prompt !== null
                                          ? encodeURIComponent(lines.prompt)
                                          : "Untitled"
                                        }`,
                                        {
                                          state: {
                                            line: lines,
                                            template_id: category?.template_id,
                                            category_id: category?.id,
                                            category_uuid: category?.uuid,
                                            line_uuid: lines?.uuid,
                                            isNarrative: template?.is_narrative_template === 1 ? true : false,
                                            target: "comment",
                                          },
                                        }
                                      );
                                      activateLine(lines?.uuid);
                                    }}
                                  >
                                    {category.prompt === null
                                      ? "Untitled"
                                      : category.prompt}
                                    : {lines.prompt === null
                                      ? "Untitled"
                                      : lines.prompt}
                                  </p>
                                  <p
                                    className="coll_content_text"
                                    onClick={() => {
                                      navigate(
                                        `/inspection/${category?.prompt !== null
                                          ? encodeURIComponent(category.prompt)
                                          : "Untitled"
                                        }/${lines.prompt !== null
                                          ? encodeURIComponent(lines.prompt)
                                          : "Untitled"
                                        }`,
                                        {
                                          state: {
                                            line: lines,
                                            template_id: category?.template_id,
                                            category_id: category?.id,
                                            category_uuid: category?.uuid,
                                            line_uuid: lines?.uuid,
                                            isNarrative: template?.is_narrative_template === 1 ? true : false,
                                            target: "comment",
                                          },
                                        }
                                      );
                                      activateLine(lines?.uuid);
                                    }}
                                  >
                                    Comment:{"  "}
                                    {getCommentDisplayText(comment)}
                                  </p>
                                  <div className="review_image_container" style={{ display: "flex !important", flexFlow: "wrap !important" }}>
                                    {comment?.comment_input_controls?.map(
                                      (commentData) => {
                                        if (commentData?.type == "Media" && commentData?.is_disabled !== 1)
                                          return commentData?.data?.filter(media => media?.is_deleted === 0)?.map((media) => (
                                            <div className="video_thumb_container" >
                                              {media.filetype === "image" ? "" : <PlayCircleIcon className="comment_play_icon" />}
                                              <img
                                                src={
                                                  media.filetype === "image"
                                                    ? `${inspectionData?.bucket_url}${media?.onlineUrl}`
                                                    : `${inspectionData?.bucket_url}${media?.thumbnail}`
                                                }
                                                onClick={() => {
                                                  navigate(
                                                    `/inspection/${category?.prompt !==
                                                      null
                                                      ? encodeURIComponent(
                                                        category.prompt
                                                      )
                                                      : "Untitled"
                                                    }/${lines.prompt !== null
                                                      ? encodeURIComponent(
                                                        lines.prompt
                                                      )
                                                      : "Untitled"
                                                    }`,
                                                    {
                                                      state: {
                                                        line: lines,
                                                        template_id:
                                                          category?.template_id,
                                                        category_id:
                                                          category?.id,
                                                        category_uuid:
                                                          category?.uuid,
                                                        line_uuid:
                                                          lines?.uuid,
                                                        isNarrative: template?.is_narrative_template === 1 ? true : false,
                                                        target: "comment",
                                                      },
                                                    }
                                                  );
                                                  activateLine(lines?.uuid);
                                                }}
                                              />
                                            </div>
                                          ));
                                      }
                                    )}
                                  </div>
                                </div>
                                <div>
                                  <CallMissedOutgoingIcon
                                    className="updrop_icon"
                                    onClick={() => {
                                      navigate(
                                        `/inspection/${category?.prompt !== null
                                          ? encodeURIComponent(category?.prompt)
                                          : "Untitled"
                                        }/${lines.prompt !== null
                                          ? encodeURIComponent(lines?.prompt)
                                          : "Untitled"
                                        }`,
                                        {
                                          state: {
                                            line: lines,
                                            template_id: category?.template_id,
                                            category_id: category?.id,
                                            category_uuid: category?.uuid,
                                            line_uuid: lines?.uuid,
                                            isNarrative: template?.is_narrative_template === 1 ? true : false,
                                            target: "comment",
                                          },
                                        }
                                      );
                                      activateLine(lines?.uuid);
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          }
                        }
                      })}
                    </>
                  ));
                })}
              </div>
            </div>
          </Grid>
        )
        }
      </div>
    </Grid>
  );
}

export default CommentReview;
